import { render } from "./FaceVerification.vue?vue&type=template&id=e3dca3ee&scoped=true"
import script from "./FaceVerification.vue?vue&type=script&lang=js"
export * from "./FaceVerification.vue?vue&type=script&lang=js"

import "./FaceVerification.vue?vue&type=style&index=0&id=e3dca3ee&scoped=true&lang=css"

import exportComponent from "D:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3dca3ee"]])

export default __exports__